import React, { useContext, useState, useEffect, useRef } from 'react';

import { Form } from 'antd';
import PropTypes from 'prop-types';

import EditableContext from '../EditableContext';

const EditableCell = ({
  title,
  editable,
  editableField,
  children,
  dataIndex,
  record,
  handleSave,
  cursor,
  ...restProps
}) => {
  const fieldRef = useRef();
  const form = useContext(EditableContext);

  const [editing, setEditing] = useState(false);

  useEffect(() => {
    if (editing && fieldRef.current) {
      if (fieldRef.current.focus) {
        fieldRef.current.focus();
      }
    }
  }, [editing]);

  const toggleEdit = () => {
    setEditing(!editing);

    form.setFieldsValue({
      [dataIndex]: record[dataIndex],
    });
  };

  const save = async () => {
    const values = await form.validateFields();

    toggleEdit();
    handleSave({ ...record, ...values });
  };

  let childNode = children;

  if (editable) {
    childNode = editing ? (
      <>
        <Form.Item
          style={{
            margin: 0,
          }}
          name={dataIndex}
          initialValue={record[dataIndex]}
          rules={[
            {
              required: true,
              message: `${title} é obrigatório`,
            },
          ]}
        >
          {editableField(fieldRef, save, toggleEdit)}
        </Form.Item>
      </>
    ) : (
      <div style={{ cursor }} onClick={toggleEdit}>
        {children}
      </div>
    );
  }

  return <td {...restProps}>{childNode}</td>;
};

EditableCell.defaultProps = {
  cursor: 'inherit',
  title: '',
  editable: false,
  editableField: () => null,
  dataIndex: '',
  record: {},
  handleSave: () => null,
};

EditableCell.propTypes = {
  cursor: PropTypes.string,
  title: PropTypes.string,
  editable: PropTypes.bool,
  editableField: PropTypes.func,
  children: PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.object, PropTypes.string])).isRequired,
  dataIndex: PropTypes.string,
  record: PropTypes.objectOf(PropTypes.any),
  handleSave: PropTypes.func,
};

export default EditableCell;
